export const Message = {
    WORDERR: 'The height and width are not empty/greater than zero.'
  };